import classNames from 'classnames';
import RewardsV2Card from '../RewardsV2Card';

import './RewardsV2List.scss';

const RewardsV2List = ({
  rewardsList,
  onClick,
  className,
  trackerProps = {},
  activeSubscription,
  cashbackMultiplierValue,
}) => (
  <div className={classNames('RewardsV2ViewList', className)}>
    {rewardsList.map((rewardItem, index) => (
      <RewardsV2Card
        key={`reward-${rewardItem.uid}`}
        index={index}
        rewardItem={rewardItem}
        onClick={onClick}
        trackerProps={trackerProps}
        activeSubscription={activeSubscription}
        cashbackMultiplierValue={cashbackMultiplierValue}
      />
    ))}
  </div>
);

export default RewardsV2List;
